// extracted by mini-css-extract-plugin
export default {"header":"navbar_header__CA6gG","wrapper":"navbar_wrapper__-+4kc","logo":"navbar_logo__eGnSm","headerText":"navbar_headerText__cG9Vg","left":"navbar_left__G0NTq"};